/**
 * Обертка для асинхронных функций, которая объединяет одинаковые параллельные вызовы.
 * Если функция вызывается с теми же аргументами, пока первый запрос еще выполняется,
 * она возвращает тот же самый Promise вместо запуска нового.
 *
 * @param fn - Оригинальная асинхронная функция, возвращающая Promise.
 * @returns Функция с той же сигнатурой, защищенная от дублирования запросов.
 */
export function dedupePromise<Args extends unknown[], Return>(
  fn: (...args: Args) => Promise<Return>,
): (...args: Args) => Promise<Return> {
  const activePromises = new Map<string, Promise<Return>>();

  return function (...args: Args): Promise<Return> {
    const cacheKey = JSON.stringify(args);

    const existingPromise = activePromises.get(cacheKey);
    if (existingPromise) {
      return existingPromise;
    }

    const newPromise = fn(...args).finally(() => {
      activePromises.delete(cacheKey);
    });

    activePromises.set(cacheKey, newPromise);

    return newPromise;
  };
}
